import React, { Fragment } from 'react';
import parse from 'html-react-parser';

const AwardsCard = ({ award }) => {
  const {
    imageUrl,
    imageAlt,
    title,
    url,
    target
  } = award;

  let imageUrlWebp;

  if (imageUrl) {
    if (imageUrl.indexOf('?') !== -1) {
      imageUrlWebp = `${imageUrl}&format=webp`;
    } else {
      imageUrlWebp = `${imageUrl}?format=webp`;
    }
  }

  const CommonInnerMarkup = (
    <Fragment>
      <div className="awards-card__inner">
        {imageUrl && (
          <picture className="awards-card__image">
            <source srcSet= {imageUrlWebp} type="image/webp"></source>
            <img src={imageUrl} alt={imageAlt} />
          </picture>
        )}
        <div className="awards-card__content">{parse(title)}</div>
      </div>
      <span className="cta-decorator-v2 cta-decorator-v2--external awards-card__link">
        <svg viewBox="0 0 19 18">
          <use href="#link-arrow-icon"></use>
        </svg>
      </span>
    </Fragment>
  );

  return (
    <a className="awards-card" href={url} target={target}>
      {CommonInnerMarkup}
    </a>
  );
};

export default AwardsCard;
